<template>
  <div class="page__footer">
    <div class="page__footer-left">
      <span
        v-if="$config.showBuildDateInFooter && !$config.isBackupApp"
        data-testid="build-date"
      >
        {{ `${$dayjs(buildDate).locale($i18n.locale).format('lll')} - ` }}
      </span>

      <span
        data-testid="pf-client-version-number"
      >
        {{ `${versionNumber} - ` }}
      </span>

      <router-link
        :to="{
          name: 'changelog',
        }"
      >
        {{ $t('page_titles.changelog') }}
      </router-link>
      |
      <LanguageSwitch
        data-testid="language-switch-footer"
        class="com_language-menu--footer"
      />

      <DevDebugBarToggle
        v-if="isDebugBarEnabled"
      />
    </div>

    <div class="page__footer-right">
      <i18n-t
        scope="global"
        keypath="layout.footer.visit_us_at"
      >
        <template #domain>
          <a
            :href="$utm($t('data.pf_links.planfred_website'), 'footer-website-link')"
            data-testid="planfred-website-link-footer"
          >
            www.planfred.com
          </a>
        </template>
      </i18n-t>
    </div>
  </div>
</template>

<script>

import isOnLocalhost from '@client-shared/utils/is-on-localhost.js'

import packageJson from '../../package.json'

import DevDebugBarToggle from '@/components/DevDebugBarToggle.vue'
import LanguageSwitch from '@/components/LanguageSwitch.vue'

export default {
  name: 'PfFooter',

  components: {
    DevDebugBarToggle,
    LanguageSwitch,
  },

  computed: {
    isDebugBarEnabled () {
      return !window.Cypress && isOnLocalhost
    },

    versionNumber () {
      return packageJson.version
    },

    buildDate () {
      return packageJson.buildDate
    },
  },
}
</script>
